import type { JSX } from 'react';
import { useI18n } from '../i18n/context.js';

export function SubmitButton({ label, pending }: { label: string; pending: boolean }): JSX.Element {
  const { t } = useI18n();
  return (
    <button
      type="submit"
      disabled={pending}
      className="rounded-[var(--kitup-radius-sm)] bg-[var(--kitup-color-accent)] px-4 py-2 font-medium text-white transition-opacity focus-visible:ring-2 focus-visible:ring-[var(--kitup-color-accent)]/50 focus-visible:ring-offset-2 focus-visible:outline-none disabled:opacity-60"
    >
      {pending ? t.common.loading : label}
    </button>
  );
}
